import { Box, Select } from "@mantine/core";
import { IconSelector } from "@tabler/icons-react";
import {
  NAV_TABS_FULL_WIDTH_LINE_STYLE,
  navyProfileNavTabBorderRadius,
} from "@/shared/styles/navTabsLayout";
import { useNavTabsStackLayout } from "@/shared/styles/useNavTabsStackLayout";
import { REQUEST_FILTER_OPTIONS, type RequestFilter } from "./dashboardTab.const";

const DASHBOARD_NAV_TAB_HEIGHT = 44;

type RequestFilterHeaderSelectProps = {
  value: RequestFilter;
  onChange: (filter: RequestFilter) => void;
};

export default function RequestFilterHeaderSelect({ value, onChange }: RequestFilterHeaderSelectProps) {
  const { isMobile: isStacked } = useNavTabsStackLayout(1, { alignItems: "stretch" });

  return (
    <Box w="100%" style={{ ...NAV_TABS_FULL_WIDTH_LINE_STYLE, flexShrink: 0 }}>
      <Box
        px={{ base: "md", sm: "lg" }}
        style={{
          display: "inline-flex",
          width: "max-content",
          maxWidth: "100%",
          minHeight: DASHBOARD_NAV_TAB_HEIGHT,
          height: DASHBOARD_NAV_TAB_HEIGHT,
          alignItems: "center",
          backgroundColor: "#04305c",
          borderRadius: navyProfileNavTabBorderRadius(isStacked, "first"),
          borderTop: "1px solid #04305c",
          borderLeft: "1px solid #04305c",
          borderRight: "1px solid #04305c",
          boxSizing: "border-box",
        }}
      >
        <Select
          value={value}
          onChange={(next) => {
            if (
              next === "all" ||
              next === "received" ||
              next === "sent" ||
              next === "suggested"
            ) {
              onChange(next);
            }
          }}
          data={REQUEST_FILTER_OPTIONS}
          allowDeselect={false}
          variant="unstyled"
          w={{ base: 200, sm: 240 }}
          aria-label="Filter requests"
          rightSection={<IconSelector size={18} color="#ffffff" stroke={1.75} />}
          styles={{
            input: {
              color: "#ffffff",
              fontWeight: 600,
              fontSize: "var(--mantine-font-size-md)",
              paddingLeft: 0,
              paddingRight: 28,
              minHeight: DASHBOARD_NAV_TAB_HEIGHT,
              height: DASHBOARD_NAV_TAB_HEIGHT,
            },
            section: {
              pointerEvents: "none",
            },
            dropdown: {
              borderColor: "#04305c",
            },
            option: {
              color: "#04305c",
              fontWeight: 500,
            },
          }}
          comboboxProps={{ withinPortal: true }}
        />
      </Box>
    </Box>
  );
}
